import { render } from "./mobile-six.vue?vue&type=template&id=3025a352&scoped=true"
const script = {}

import "./mobile-six.vue?vue&type=style&index=0&id=3025a352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3025a352"]])

export default __exports__